// Generated by purs version 0.15.15
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Control_Bind from "../Control.Bind/index.js";
import * as Data_Bifunctor from "../Data.Bifunctor/index.js";
import * as Data_Either from "../Data.Either/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_Functor_Compose from "../Data.Functor.Compose/index.js";
import * as Data_LogicExpr_AST from "../Data.LogicExpr.AST/index.js";
import * as Data_LogicExpr_Parser from "../Data.LogicExpr.Parser/index.js";
import * as Data_LogicValues_B4 from "../Data.LogicValues.B4/index.js";
import * as Data_LogicValues_ToB4 from "../Data.LogicValues.ToB4/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Newtype from "../Data.Newtype/index.js";
var lmap = /* #__PURE__ */ Data_Bifunctor.lmap(Data_LogicExpr_AST.bifunctorValueExpr);
var map = /* #__PURE__ */ Data_Functor.map(Data_LogicExpr_AST.functorExpr);
var lmap1 = /* #__PURE__ */ Data_Bifunctor.lmap(Data_Bifunctor.bifunctorEither);
var pure = /* #__PURE__ */ Control_Applicative.pure(Data_LogicExpr_AST.applicativeExpr);
var unwrap = /* #__PURE__ */ Data_Newtype.unwrap();
var bind = /* #__PURE__ */ Control_Bind.bind(Data_LogicExpr_AST.bindValueExpr);
var splitClassicalVal = /* #__PURE__ */ Data_LogicValues_ToB4.splitClassicalVal(Data_LogicValues_ToB4.toB4B4);
var map1 = /* #__PURE__ */ Data_Functor.map(Data_Either.functorEither);
var pure1 = /* #__PURE__ */ Control_Applicative.pure(Data_LogicExpr_AST.applicativeValueExpr);
var toB4ExprValueExpr = function (dictToB4) {
    return {
        toB4Expr: lmap(Data_LogicValues_ToB4.toB4(dictToB4))
    };
};
var toB4ExprValueExpr1 = /* #__PURE__ */ toB4ExprValueExpr(Data_LogicValues_ToB4.toB4B4);
var toB4ExprExpr = {
    toB4Expr: /* #__PURE__ */ (function () {
        var $49 = map(Data_Either.Right.create);
        return function ($50) {
            return Data_LogicExpr_AST.ValueExpr($49($50));
        };
    })()
};
var toB4ExprEither = function (dictToB4) {
    return {
        toB4Expr: (function () {
            var $51 = lmap1(Data_LogicValues_ToB4.toB4(dictToB4));
            return function ($52) {
                return Data_LogicExpr_AST.ValueExpr(pure($51($52)));
            };
        })()
    };
};
var toB4Expr = function (dict) {
    return dict.toB4Expr;
};
var toB4ExprCompose = function (dictToB4Expr) {
    var toB4Expr2 = toB4Expr(dictToB4Expr);
    return function (dictToB4Expr1) {
        var toB4Expr3 = toB4Expr(dictToB4Expr1);
        return {
            toB4Expr: function ($53) {
                return (function (v) {
                    return bind(v)(toB4Expr3);
                })(toB4Expr2(unwrap($53)));
            }
        };
    };
};
var toB4Expr1 = /* #__PURE__ */ toB4Expr(/* #__PURE__ */ toB4ExprCompose(/* #__PURE__ */ toB4ExprEither(Data_LogicValues_ToB4.toB4Boolean))(/* #__PURE__ */ toB4ExprValueExpr(Data_LogicValues_ToB4["toB4B4$prime"])));
var trimClassical$prime = function (dictToB4Expr) {
    var $54 = map1(Data_LogicExpr_AST.ValueExpr);
    var $55 = map(function ($58) {
        return unwrap(splitClassicalVal($58));
    });
    var $56 = toB4Expr(dictToB4Expr);
    return function ($57) {
        return $54(Data_LogicExpr_AST.trimBoolValues(Data_LogicExpr_AST.ValueExpr($55(unwrap($56($57))))));
    };
};
var trimClassical = function (dictToB4Expr) {
    var $59 = trimClassical$prime(dictToB4Expr);
    return function ($60) {
        return toB4Expr1(Data_Functor_Compose.Compose($59($60)));
    };
};
var trimClassical1 = /* #__PURE__ */ trimClassical(toB4ExprValueExpr1);
var substitute = function (dictFunctor) {
    var map2 = Data_Functor.map(dictFunctor);
    return function (f) {
        return function (xs) {
            return map2(function (x) {
                return Data_Maybe.maybe(new Data_Either.Right(x))(Data_Either.Left.create)(f(x));
            })(xs);
        };
    };
};
var substitute1 = /* #__PURE__ */ substitute(Data_LogicExpr_AST.functorValueExpr);
var substituteTerms = function (f) {
    var $61 = substitute1(f);
    return function ($62) {
        return (function (v) {
            return bind(v)(function (v1) {
                if (v1 instanceof Data_Either.Left) {
                    return Data_LogicExpr_AST.value(v1.value0);
                };
                if (v1 instanceof Data_Either.Right) {
                    return pure1(v1.value0);
                };
                throw new Error("Failed pattern match at Data.LogicExpr.ToB4Expr (line 48, column 28 - line 50, column 36): " + [ v1.constructor.name ]);
            });
        })($61($62));
    };
};
var fromString = /* #__PURE__ */ (function () {
    var $63 = toB4Expr(toB4ExprCompose(toB4ExprEither(Data_LogicValues_ToB4.toB4ParseError))(toB4ExprValueExpr1));
    return function ($64) {
        return $63(Data_Functor_Compose.Compose(Data_LogicExpr_Parser["parseExpression$prime"]($64)));
    };
})();
var evaluateB4 = /* #__PURE__ */ (function () {
    var $65 = Data_LogicExpr_AST.evaluate(Data_LogicValues_B4.heytingAlgebraB4);
    var $66 = map(Data_Either.fromLeft(Data_LogicValues_B4.Indeterminate.value));
    return function ($67) {
        return $65($66(unwrap($67)));
    };
})();
var bindB4Terms = function (dictToB4Expr) {
    var toB4Expr2 = toB4Expr(dictToB4Expr);
    return function (dictToB4Expr1) {
        var toB4Expr3 = toB4Expr(dictToB4Expr1);
        return function (f) {
            return function ($68) {
                return trimClassical1((function (v) {
                    return bind(v)(function (t) {
                        return Data_Maybe.maybe(pure1(t))(toB4Expr3)(f(t));
                    });
                })(toB4Expr2($68)));
            };
        };
    };
};
export {
    toB4Expr,
    trimClassical$prime,
    trimClassical,
    substitute,
    substituteTerms,
    bindB4Terms,
    evaluateB4,
    fromString,
    toB4ExprExpr,
    toB4ExprEither,
    toB4ExprValueExpr,
    toB4ExprCompose
};
//# sourceMappingURL=index.js.map
